import { render, staticRenderFns } from "./InvoiceOrderModal.vue?vue&type=template&id=54b50e80&"
import script from "./InvoiceOrderModal.vue?vue&type=script&lang=js&"
export * from "./InvoiceOrderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/blocks/InvoiceOrderModal.vue
// module id = null
// module chunks = 